<template>
    <!-- <a-select default-value="bn" :value="selectedLanguage" style="width: 120px" @change="handleChange">
        <a-select-option value="bn">
            বাংলা
        </a-select-option>
        <a-select-option value="en">
            English
        </a-select-option>
    </a-select> -->

    <a-radio-group v-model="selectedLanguage" @change="handleChange" button-style="solid">
        <a-radio-button value="bn">বাংলা</a-radio-button>
        <a-radio-button value="en">English</a-radio-button>
    </a-radio-group>
</template>

<script>
import i18n from './i18n';
import { useLocaleStore } from '../stores/locale-store';
import { mapActions, mapState } from 'pinia';

export default {
    data() {
        return {
            selectedLanguage: 'bn',
        }
    },
    computed: {
        ...mapState(useLocaleStore, [ 'locale' ])
    },
    methods: {
        ...mapActions(useLocaleStore, [ 'setLocale' ]),
        handleChange(value) {
            console.log(value.target.value);
            // this.selectedLanguage = value;
            this.selectedLanguage = value.target.value;
            // i18n.locale = value;
            // if (value == 'bn')
            //     document.body.classList.add('bn');
            // else
            //     document.body.classList.remove("bn");
            // this.setLocale(value);
            this.setLocale(value.target.value);
        }
    },
    watch: {
        locale: {
            immediate: true,
            handler() {
                this.selectedLanguage = this.locale;
            }
            
        }
    }
}
</script>